import React, { useState } from 'react';
import { SOURCE_OPTIONS } from '../../utils/constants';

export default function ScrapeButton({ onScrape, scraping, status }) {
  const [sources, setSources] = useState(['ebay', 'vinted']);

  const toggleSource = (value) => {
    setSources((prev) =>
      prev.includes(value)
        ? prev.filter((s) => s !== value)
        : [...prev, value]
    );
  };

  return (
    <div className="scrape-button-container">
      <div className="source-checkboxes">
        {SOURCE_OPTIONS.filter(s => s.value !== 'cardmarket').map((s) => (
          <label key={s.value} className="checkbox-label">
            <input
              type="checkbox"
              checked={sources.includes(s.value)}
              onChange={() => toggleSource(s.value)}
              disabled={scraping}
            />
            {s.label}
          </label>
        ))}
      </div>
      <button
        className="btn btn-primary"
        onClick={() => onScrape(sources)}
        disabled={scraping || sources.length === 0}
      >
        {scraping ? 'Scraping...' : 'Scrape New Cards'}
      </button>
      {status && (
        <div className="scrape-status">
          <span className={`status-badge status-${status.status}`}>
            {status.status}
          </span>
          {status.cards_found > 0 && (
            <span className="status-detail">
              Found: {status.cards_found} | New: {status.cards_new}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
